const blocks = document.querySelectorAll('.block-toggle-txt');

if (blocks.length !== 0) {
    
    blocks.forEach(block => {
        const outer = block.querySelector('.block-toggle-txt-wrap-2');
        const inner = block.querySelector('.block-toggle-txt-wrap-3');
        const toggle = block.querySelector('.block-toggle-txt-read-toggle');

        if (!outer || !inner || !toggle) return;
        const collapsedHeight = 360;
        const fullHeight = inner.scrollHeight;
        

        if (fullHeight <= collapsedHeight) {
            toggle.style.display = 'none';
            outer.style.height = 'auto';
            return;
        }
        outer.classList.add('is-enable-expanded');
        outer.style.height = `${collapsedHeight}px`;
        outer.style.transition = 'height 0.4s ease';
        toggle.addEventListener('click', e => {
            e.preventDefault();
            const isExpanded = block.classList.contains('expanded');
            if (isExpanded) {
                outer.style.height = `${collapsedHeight}px`;
                block.classList.remove('expanded');
                outer.addEventListener('transitionend', function cb() {
                    outer.removeEventListener('transitionend', cb);
                    // console.log('✅');
                    ScrollTrigger.refresh(true);
                });
            } else {
                outer.style.height = `${fullHeight}px`;
                block.classList.add('expanded');
                outer.addEventListener('transitionend', function cb() {
                    outer.removeEventListener('transitionend', cb);
                    // console.log('✅');
                    ScrollTrigger.refresh(true);
                });
            }
        });
    });
}
//-------------------------------------------------------------------
// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = {37: 1, 38: 1, 39: 1, 40: 1};
function preventDefault(e) {
    e.preventDefault();
}
function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
}
// modern Chrome requires { passive: false } when adding event
var supportsPassive = false;
try {
    window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: function () {
            supportsPassive = true;
        }
    }));
} catch (e) {
}
var wheelOpt = supportsPassive ? {passive: false} : false;
var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';



// call this to Disable
function disableScroll() {
    return;
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
}
// call this to Enable
function enableScroll() {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
}
//-------------------------------------------------------------------
 /*if (document.getElementById('is-homepage')) {
    disableScroll();
}*/

window.addEventListener('load', () => {
    if (typeof tl_hero !== 'undefined') {
        tl_hero.play();
    }
});
//-------------------------------------------------------------------
function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
}
function getCookie(name) {
    return document.cookie.split('; ').reduce((r, v) => {
        const parts = v.split('=');
        return parts[0] === name ? decodeURIComponent(parts[1]) : r
    }, '');
}
const closeBtn = document.getElementById('utility-bar-my__close');
const bar = document.getElementById('utility-bar-my');
if (getCookie('utilityBarClosed') === 'true') {
    if (bar) {
        document.body.classList.add('is-hide-utility-bar-2');
    }
}
if (getCookie('utilityBarClosed') !== 'true' && !document.querySelector('.hero-anim-js')) {
    document.body.classList.remove('is-hide-utility-bar');
    slideDown(bar, 500)
}
if (closeBtn && bar) {
    closeBtn.addEventListener('click', function () {
        slideUp(bar, 500, function () {
            setCookie('utilityBarClosed', 'true', 7);
        });
    });
}
//-------------------------------------------------------------------
let  utilityBar = bar,
    header = document.querySelector('#header-my'),
    utilityHeight = bar?.offsetHeight || 0,
    headerHeight = header?.offsetHeight || 0;
function updateHeaderVars() {
    utilityHeight = bar?.offsetHeight || 0;
    headerHeight = header?.offsetHeight || 0;
    document.documentElement.style.setProperty('--utility-bar-height', `${utilityHeight}px`);
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
}
window.addEventListener('load', updateHeaderVars);
window.addEventListener('resize', updateHeaderVars);
const menuBtn = document.getElementById('menu-btn');
if (menuBtn) {
    menuBtn.addEventListener('click', function () {
        document.body.classList.toggle('is-open-menu');
    });
}
//-------------------------------------------------------------------
document.querySelectorAll('.s-review-slider').forEach(section => {
    let imageSwiper = new Swiper(section.querySelector('.s-review-slider__pic-slider'), {
        direction: 'vertical', speed: 900, parallax: true, allowTouchMove: false,
    });
    let textSwiper = new Swiper(section.querySelector('.s-review-slider__txt-slider'), {
        effect: 'fade',
        fadeEffect: {crossFade: true},
        speed: 900,
        spaceBetween: 30,
        allowTouchMove: false,
        pagination: {
            el: section.querySelector('.swiper-pagination'),
            type: 'fraction',
            formatFractionCurrent: num => num.toString().padStart(2, '0'),
            formatFractionTotal: num => num.toString().padStart(2, '0')
        },
        navigation: {
            nextEl: section.querySelector('.swiper-button-next'), prevEl: section.querySelector('.swiper-button-prev'),
        },
        on: {
            slideChange(swiper) {
                imageSwiper.slideTo(swiper.realIndex);
            }
        }
    });
});
//-------------------------------------------------------------------
let imageSwiper = new Swiper(document.querySelector('#s-drops__buttons'), {
    speed: 900, spaceBetween: 12, slidesPerView: 'auto', slideToClickedSlide: true, threshold: 15,
});
//-------------------------------------------------------------------
let modalPlayer = null;
document.querySelectorAll('a[href*="modal"]').forEach(function (caller) { 
    caller.addEventListener('click', function (e) {
        e.preventDefault();
        const targetSelector = this.getAttribute('href');
        const modal = document.querySelector(targetSelector);
        const videoSrc = this.dataset.videoSrc;
        if (modal) {
            modal.classList.add('is-open');
            document.body.classList.add('modal-is-open');
            const video = modal.querySelector('video');
            if (video && videoSrc) {
                video.setAttribute('src', videoSrc);
                modalPlayer = new Plyr(video, {
                    iconUrl: icons_plyr_path
                });
            }
        }
    });
});
document.querySelectorAll('.modal-close-js').forEach(function (closer) {
    closer.addEventListener('click', function () {
        const modal = this.closest('.modal-js');
        if (modal) {
            modal.classList.remove('is-open');
            document.body.classList.remove('modal-is-open');
            const video = modal.querySelector('video');
            if (video) {
                if (modalPlayer) {
                    modalPlayer.pause();
                    modalPlayer.destroy();
                    modalPlayer = null;
                }
                video.removeAttribute('src');
                video.load();
            }
        }
    });
});
//-------------------------------------------------------------------
let mainPageWrap = document.querySelector('.main-page-wrap');
function debounce(func) {
    var timer;
    return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, 300, event);
    };
}
function isSafari() {
    return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (!!window.safari && typeof window.safari === "object") || (typeof window.ApplePaySession !== "undefined"));
}
function isWindows() {
    return /windows/i.test(navigator.userAgent);
}
if (isSafari()) {
    document.documentElement.classList.add('safari-browser');
}
if (isWindows()) {
    document.documentElement.classList.add('windows-browser');
}
function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
function isEnableCustomScroll() {
     return true;
    const hasDisabledScroll = document.querySelector('.disabled-smooth-scroll-js');
    if (hasDisabledScroll) {
        document.body.classList.add('smooth-scroll-css');
        return true;
    }
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
let vh_ = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', vh_ + 'px');
document.documentElement.style.setProperty('--vh-2', vh_ + 'px');
var isMobile = /iPhone|iPad|iPod|midp|rv:1.2.3.4|ucweb|windows ce|windows mobile|BlackBerry|IEMobile|Opera Mini|Android/i.test(navigator.userAgent);
window.addEventListener('resize', function () {
    vh_ = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh_ + 'px');
    if (!isMobile) {
        document.documentElement.style.setProperty('--vh-2', vh_ + 'px');
    }
});
//--------------------------------------------------------------------
let lenis = null, bodyScrollBar = null, isOffsetTop = false;
function scroll_offset(scroll) {
    if (scroll > 0) {
        if (!isOffsetTop) {
            document.body.classList.add('is-offset-top');
            isOffsetTop = true;
        }
    } else {
        if (isOffsetTop) {
            document.body.classList.remove('is-offset-top');
            isOffsetTop = false;
        }
    }
}
function openModal(scrollbar) {
    scrollbar.updatePluginOptions('modal', {open: true});
}
function closeModal(scrollbar) {
    scrollbar.updatePluginOptions('modal', {open: false});
}
const isBlogPage = document.body.classList.contains('template-article') 
                || document.body.classList.contains('template-blog');

if (!isEnableCustomScroll() && !isBlogPage) { 
    if (!isSafari()) {
        document.body.classList.add('Lenis-init');
        lenis = new Lenis({
            duration: 1.5,
            smooth: true,
            direction: 'vertical',
            gestureDirection: 'vertical',
            syncTouch: true,
            smoothTouch: false,
            touchMultiplier: 1.5,
            wheelMultiplier: 0.8,
            wrapper: document.body.querySelector('#body-content-wrap'),
            content: document.body.querySelector('#body-content'),
        });
        lenis.on('scroll', ({scroll}) => {
            ScrollTrigger.update();
            scroll_offset(scroll);
        });
        gsap.ticker.add((time) => {
            lenis.raf(1000 * time);
        });
        gsap.ticker.lagSmoothing(0);
        if (document.getElementById('is-homepage')) {
            lenis.stop();
        }
    }
    if (isSafari()) {
        document.body.classList.add('Scrollbar-init');
        const elements = document.querySelectorAll('.custom-scrollbar');
        elements.forEach(el => {
            el.classList.remove('custom-scrollbar', 'hide-scrollbar');
            el.setAttribute('data-scrollbar', '');
        });
        const ScrollbarPlugin = window.Scrollbar.ScrollbarPlugin;
        const Scrollbar = window.Scrollbar;
        class ModalPlugin extends ScrollbarPlugin {
            static pluginName = 'modal';
            static defaultOptions = {
                open: false,
            };
            transformDelta(delta) {
                return this.options.open ? {x: 0, y: 0} : delta;
            }
        }
        Scrollbar.use(ModalPlugin);
        const bodyScrollBar_all = Scrollbar.initAll({
            ignoreEvents: (event) => {
                return event.target.closest('[data-scroll="exclude"]');
            },
        });
        const scrollableBlocks = document.querySelectorAll('[data-scroll="exclude"]');
        scrollableBlocks.forEach((block) => {
            block.addEventListener('wheel', (e) => e.stopPropagation(), {passive: false});
            block.addEventListener('touchmove', (e) => e.stopPropagation(), {passive: false});
        });
        bodyScrollBar = Scrollbar.get(document.querySelector('#body-content-wrap'));
        ScrollTrigger.scrollerProxy('#body-content-wrap', {
            scrollTop(value) {
                if (arguments.length) {
                    bodyScrollBar.scrollTop = value;
                }
                return bodyScrollBar.scrollTop;
            }, getBoundingClientRect() {
                return {
                    top: 0, left: 0, width: window.innerWidth, height: window.innerHeight,
                };
            },
        });
        bodyScrollBar.addListener(() => {
            ScrollTrigger.update();
            const currentScrollTop = bodyScrollBar.offset.y;
            scroll_offset(currentScrollTop);
        });
        if (document.getElementById('is-homepage')) {
            openModal(bodyScrollBar)
        }
    }
}
if (isEnableCustomScroll()) {
    
    scroll_offset(window.scrollY);
    window.addEventListener('scroll', function () {
        scroll_offset(window.scrollY);
    });
}
//--------------------------------------------------------------------
function setScrollTrigger() {
    const scroller = !isEnableCustomScroll() ? '#body-content-wrap' : 'body';
    ScrollTrigger.defaults({
        scroller: scroller, pinType: !isEnableCustomScroll() ? 'transform' : 'fixed',
    });
}
setScrollTrigger();
window.addEventListener('resize', setScrollTrigger);
//--------------------------------------------------------------------
// if ('scrollRestoration' in history) {
//     history.scrollRestoration = 'manual';
// }
// // pageshow
// window.addEventListener('pageshow', (event) => {
//     if (mainPageWrap) {
//         mainPageWrap.classList.add('show-after');
//         window.scrollTo(0, 0);
//         setTimeout(() => {
//             mainPageWrap.classList.remove('show-after');
//         }, 300);
//     }
// });
// // load
// window.addEventListener('load', () => {
//     window.scrollTo(0, 0);
//     if (mainPageWrap) {
//         mainPageWrap.classList.remove('show-after');
//     }
// });
// // before unload
// window.addEventListener('beforeunload', () => {
//     if (mainPageWrap) {
//         mainPageWrap.classList.add('show-after');
//     }
//     window.scrollTo(0, 0);
// });
//--------------------------------------------------------------------
window.addEventListener('load', function () {
    document.body.classList.add('window-load');
});
//--------------------------------------------------------------------
const triggers = document.querySelectorAll('[data-scrollto]');
if (triggers.length) {
    triggers.forEach(trigger => {
        trigger.addEventListener('click', function (event) {
            const elementId = this.getAttribute('data-scrollto');
            const target = document.querySelector(elementId);
            if (!target) return;
            let paddingOffset = 0;
            if (this.hasAttribute('data-scroll-offset-default') && header) {
                paddingOffset = header.offsetHeight;
                if (window.innerWidth < 992) {
                    paddingOffset += 40;
                }
            }
            const targetOffset = target.getBoundingClientRect().top + window.pageYOffset - paddingOffset;
            if (!isEnableCustomScroll()) {
                if (!isSafari()) {
                    lenis.scrollTo(target, {
                        offset: paddingOffset, immediate: false, duration: 1.2, easing: t => t
                    });
                } else {
                    bodyScrollBar.scrollIntoView(target, {
                        offsetLeft: 0, offsetTop: paddingOffset, alignToTop: true, onlyScrollIfNeeded: false,
                    });
                }
            } else {
                window.scrollTo({
                    top: targetOffset, behavior: 'smooth'
                });
            }
            event.preventDefault();
        });
    });
}
//--------------------------------------------------------------------
if (window.innerWidth < 992) {
    const selectors = ['.s-event-collection__btn-wrap', '.s-highlight__txt-wrap', '.s-highlight__btn-wrap', '.s-highlight__pic-wrap', '.s-merch__btn-wrap'];
    selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
            el.classList.add('batch-item-js', 'batch-item--def-js');
        });
    });
}
//--------------------------------------------------------------------
// Split text logic (pure JS replacement for jQuery version)
const splitTextElements = document.querySelectorAll('.split-text-init-js');
splitTextElements.forEach((item) => {
    let convertToLine = item;
    const pTags = item.querySelectorAll('p,li,h4,h3,h5,h6');
    if (pTags.length > 0) {
        convertToLine = pTags;
    }
    if (convertToLine instanceof NodeList || Array.isArray(convertToLine)) {
        convertToLine.classList.add('split-text-lines-js');
        convertToLine.forEach(el => {
            new SplitText(el, {
                type: 'lines', linesClass: 'line-st', mask: 'lines', aria: 'none',
            });
        });
    } else {
        convertToLine.classList.add('split-text-chars-js');
        new SplitText(convertToLine, {
            type: 'chars,lines', linesClass: 'line-st', charsClass: 'char-st', mask: 'lines', aria: 'none',
        });
    }
});
// Batch animation logic
const batchItems = document.querySelectorAll('.batch-item-js');
if (batchItems.length > 0) {
    if (document.querySelectorAll('.batch-item--text-js.split-text-lines-js .line-st').length > 0) {
        gsap.set('.batch-item--text-js.split-text-lines-js .line-st', {
            yPercent: 100
        });
    }
    if (document.querySelectorAll('.batch-item--text-js.split-text-chars-js .char-st').length > 0) {
        gsap.set('.batch-item--text-js.split-text-chars-js .char-st', {
            yPercent: 100
        });
    }
    if (document.querySelectorAll('.batch-item--def-js').length > 0) {
        gsap.set('.batch-item--def-js', {
            y: 30, autoAlpha: 0,
        });
    }
    if (document.querySelectorAll('.batch-item--static-js').length > 0) {
        gsap.set('.batch-item--static-js', {
            autoAlpha: 0,
        });
    }
    if (document.querySelectorAll('.batch-item--from-right-js').length > 0) {
        gsap.set('.batch-item--from-right-js', {
            x: '15%', autoAlpha: 0,
        });
    }
    if (document.querySelectorAll('.batch-item--from-left-js').length > 0) {
        gsap.set('.batch-item--from-left-js', {
            y: '-15%', autoAlpha: 0,
        });
    }
    ScrollTrigger.batch('.batch-item-js.batch-item--text-js', {
        start: 'top bottom', once: true, onEnter: batch => {
            batch.forEach((card, index) => {
                if (card.classList.contains('split-text-lines-js')) {
                    const lines = card.querySelectorAll('.line-st');
                    gsap.to(lines, {
                        yPercent: 0, duration: 0.6, stagger: 0.15, ease: 'power1.inOut', delay: index * 0.1
                    });
                }
                if (card.classList.contains('split-text-chars-js')) {
                    const chars = card.querySelectorAll('.char-st');
                    gsap.to(chars, {
                        yPercent: 0,
                        duration: window.innerWidth < 992 ? 0.25 : 0.5,
                        stagger: 0.05,
                        ease: 'power3.inOut',
                        delay: index * 0.1
                    });
                }
            });
        }
    });
    ScrollTrigger.batch('.batch-item-js:not(.batch-item--text-js)', {
        start: 'top bottom-=100', once: true, onEnter: batch => {
            batch.forEach((card, index) => {
                gsap.to(card, {
                    duration: 0.7,
                    ease: typeof ease_default !== 'undefined' ? ease_default : 'power1.out',
                    x: 0,
                    y: 0,
                    delay: index * 0.1
                });
                gsap.to(card, {
                    duration: .5,
                    ease: typeof ease_default !== 'undefined' ? ease_default : 'power1.out',
                    autoAlpha: 1,
                    delay: index * 0.1 + 0.1
                });
            });
        }
    });
}
//--------------------------------------------
if (window.innerWidth < 992 && document.querySelector('#is-homepage')) {
    const images = document.querySelectorAll('.event-card__img');
    images.forEach(img => {
        img.classList.add('parallax-js', 'parallax-img-js', 'parallax-y-js', 'is-parallax-trigger-js');
        img.setAttribute('data-parallax-value', '15');
        if (img.parentElement) {
            img.parentElement.classList.add('parallax-trigger-js');
        }
    });
}
//--------------------------------------------
const parallaxes = document.querySelectorAll('.parallax-js');
if (parallaxes.length) {
    parallaxes.forEach((el) => {
        const isImg = el.classList.contains('parallax-img-js');
        const isBlock = el.classList.contains('parallax-block-js');
        const isReverse = el.classList.contains('parallax-reverse-js');
        const translateValue = parseFloat(el.dataset.parallaxValue) || 0;
        const translateY = el.classList.contains('parallax-y-js') ? translateValue : 0;
        const translateX = el.classList.contains('parallax-x-js') ? translateValue : 0;
        const scale = el.classList.contains('parallax-scale-js') ? translateValue : 1;
        const scrubVal = el.dataset.parallaxScrub !== undefined ? el.dataset.parallaxScrub : true;
        const startPos = el.dataset.parallaxTriggerStart || 'top bottom';
        const endPos = el.dataset.parallaxTriggerEnd || 'bottom top';
        const trig = el.classList.contains('is-parallax-trigger-js') ? el.closest('.parallax-trigger-js') : el;
        const trigEnd = el.dataset.endTrigger || trig;
        if (isImg && (translateY || translateX)) {
            const translateYVal = isReverse ? 0 : -translateY;
            const translateXVal = isReverse ? 0 : -translateX;
            Object.assign(el.style, {
                height: `calc(100% + ${translateY}%)`,
                width: `calc(100% + ${translateX}%)`,
                position: 'relative',
                top: `${translateYVal}%`,
                left: `${translateXVal}%`
            });
        }
        if (isBlock && (translateY || translateX)) {
            let translateYVal = translateY;
            let translateXVal = translateX;
            if (!isReverse) {
                translateYVal *= -1;
                translateXVal *= -1;
            }
            Object.assign(el.style, {
                position: 'relative', top: `${translateYVal}%`, left: `${translateXVal}%`
            });
        }
        const section = el.closest('section');
        let bro_safari = isSafari();
        const parallaxTL = gsap.timeline({
            scrollTrigger: {
                trigger: trig, endTrigger: trigEnd, start: startPos, end: endPos, scrub: scrubVal,
                pin: false, onEnter: () => {
                    if (bro_safari && section) section.classList.add('use-will-change-on-children');
                }, onLeave: () => {
                    if (bro_safari && section) section.classList.remove('use-will-change-on-children');
                }, onEnterBack: () => {
                    if (bro_safari && section) section.classList.add('use-will-change-on-children');
                }, onLeaveBack: () => {
                    if (bro_safari && section) section.classList.remove('use-will-change-on-children');
                }
            }
        });
        let translateYVal = translateY;
        let translateXVal = translateX;
        if (isReverse) {
            if (translateY) translateYVal = -translateY + 3;
            if (translateX) translateXVal = -translateX + 3;
        }
        parallaxTL.to(el, {
            xPercent: translateXVal, yPercent: translateYVal, scale: scale, duration: 1, ease: 'none'
        });
    });
}
//--------------------------------------------
function slideUp(element, duration = 300, callback) {
    if (!element || element.dataset.sliding === 'true') return;
    element.dataset.sliding = 'true';
    const style = window.getComputedStyle(element);
    const height = element.offsetHeight;
    element.style.height = height + 'px';
    element.style.overflow = 'hidden';
    element.style.transition = `height ${duration}ms ease, opacity ${duration}ms ease`;
    element.offsetHeight; // force reflow
    requestAnimationFrame(() => {
        element.style.height = '0px';
        element.style.opacity = '0';
    });
    setTimeout(() => {
        element.style.display = 'none';
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition');
        element.style.removeProperty('opacity');
        delete element.dataset.sliding;
        if (typeof callback === 'function') callback();
    }, duration);
}
function slideDown(element, duration = 300, callback) {
    if (!element || element.dataset.sliding === 'true') return;
    element.dataset.sliding = 'true';
    element.style.removeProperty('display');
    let display = window.getComputedStyle(element).display;
    if (display === 'none') display = 'block';
    element.style.display = display;
    // Установим временно height = auto, чтобы узнать высоту
    element.style.height = 'auto';
    const targetHeight = element.offsetHeight;
    element.style.height = '0';
    element.style.opacity = '0';
    element.style.overflow = 'hidden';
    element.offsetHeight; // force reflow
    element.style.transition = `height ${duration}ms ease, opacity ${duration}ms ease`;
    requestAnimationFrame(() => {
        element.style.height = targetHeight + 'px';
        element.style.opacity = '1';
    });
    setTimeout(() => {
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition');
        element.style.removeProperty('opacity');
        delete element.dataset.sliding;
        if (typeof callback === 'function') callback();
    }, duration);
}
//--------------------------------------------
if (!isTouchDevice()) {
    document.querySelectorAll('.video-anim-container-js').forEach(container => {
        const btn = container.querySelector('.video-anim-btn-js');
        if (!btn) return;
        gsap.set(btn, {
            scale: 0, xPercent: -50, yPercent: -50,
        });
        const xTo = gsap.quickTo(btn, 'x', {duration: 0.4, ease: 'power3'});
        const yTo = gsap.quickTo(btn, 'y', {duration: 0.4, ease: 'power3'});
        container.addEventListener('mouseenter', () => {
            gsap.to(btn, {scale: 1, duration: 0.3, ease: 'power3.out'});
        });
        container.addEventListener('mouseleave', () => {
            gsap.to(btn, {scale: 0, duration: 0.3, ease: 'power3.in'});
        });
        container.addEventListener('mousemove', e => {
            const rect = container.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            xTo(x);
            yTo(y);
        });
        xTo(container.offsetWidth / 2);
        yTo(container.offsetHeight / 2);
    });
} else {
    document.body.classList.add('is-touch-device');
}
//--------------------------------------------
document.querySelectorAll('.video-js').forEach(video => {
    video.addEventListener('mouseenter', () => {
        if (video.paused) {
            video.play();
        }
    });
    video.addEventListener('mouseleave', () => {
        if (!video.paused) {
            video.pause();
        }
    });
});
document.querySelectorAll('.video-overlay-js').forEach(overlay => {
    overlay.addEventListener('mouseenter', () => {
        const parent = overlay.closest('.video-container-js') || overlay.parentElement;
        const video = parent.querySelector('.video-js');
        if (video && video.paused) {
            video.play();
        }
    });
    overlay.addEventListener('mouseleave', () => {
        const parent = overlay.closest('.video-container-js') || overlay.parentElement;
        const video = parent.querySelector('.video-js');
        if (video && !video.paused) {
            video.pause();
        }
    });
});
//--------------------------------------------
let tl_hero = gsap.timeline({
    paused: true, defaults: {
        duration: .5, ease: 'power3.inOut',
    }, onComplete: function () {
        if (document.getElementById('is-homepage')) {
            // enableScroll();
            document.body.classList.add('is-enable-scroll');
            if (lenis) {
                lenis.start();
            }
            if (bodyScrollBar) {
                closeModal(bodyScrollBar)
            }
        }
        slideDown(bar, 500, function () {
            document.body.classList.remove('is-hide-utility-bar');
        })
    }
});
// ease: "power4.inOut", ease: "power4.out", ease: 'power3.inOut', ease_default = 'power3.out', 'power1.inOut',
if (document.querySelector('.hero-anim-js')) {
    const logo = document.querySelector('#header-my__logo-wrap');
    const logoWidth = 86;
    const logoHeight = 34;
    const winWidth = window.innerWidth;
    const winHeight = window.innerHeight;
    const maxScaleX = winWidth / logoWidth;
    const maxScaleY = winHeight / logoHeight;
    const dynamicScale = Math.min(maxScaleX, maxScaleY, 10);
    gsap.set('#header-my__border', {scaleX: 0});
    gsap.set(logo, {
        scale: dynamicScale
    });
    gsap.set('.header-my__logo-letter-js', {yPercent: -102})
    gsap.set('#header-my__anim-container', {autoAlpha: 0, x: 150})
    gsap.set('#s-hero__txt-wrap', {autoAlpha: 0})
    new SplitText('#s-hero__title .s-hero__title-line-js', {
        type: 'chars', charsClass: 'char-anim-js'
    });
    gsap.set('#s-hero__title .char-anim-js', {
        yPercent: 100
    })
    gsap.set('#s-hero__form-cta', {autoAlpha: 0})
    gsap.set('#s-hero__img-wrap', {scale: 0})
    document.getElementById('s-hero__video')?.pause();
    tl_hero
    .to('.header-my__logo-letter-js', {
        stagger: .05, yPercent: 0
    })
    .to(logo, {
        scale: 1
    }).addLabel('logo-anim')
    .to('#header-my__border', {
        scaleX: 1
    }, 'logo-anim-=.45')
    .to('#header-my__anim-container', {
        autoAlpha: 1, x: 0
    }, 'logo-anim-=.4')
    .to('#s-hero__txt-wrap', {
        autoAlpha: 1
    }, 'logo-anim-=.35')
    .to('#s-hero__form-cta', {
        autoAlpha: 1
    }, 'logo-anim-=.33')
    .to('#s-hero__img-wrap', {
        scale: 1, onComplete: function () {
            gsap.set('#s-hero__video-anim-btn', {
                visibility: 'visible'
            })
        }
    }, 'logo-anim-=.33')
    .to('#s-hero__title-line--1 .char-anim-js', {
        yPercent: 0, stagger: .05,
    }, 'logo-anim-=.3')
    .to('#s-hero__title-line--2 .char-anim-js', {
        yPercent: 0, stagger: .05,
    }, 'logo-anim-=.33')
    .to('#s-hero__title-line--3 .char-anim-js', {
        yPercent: 0, stagger: .05,
    }, 'logo-anim-=.36')
    tl_hero.play();
}
//--------------------------------------------------------------------
const container = document.getElementById('s-hero-video-container');
const imgWrap2 = document.getElementById('s-hero__img-wrap-2');
const defContainer = document.getElementById('s-hero__img-wrap');
if (container && imgWrap2 && defContainer && window.innerWidth > 991) {
    const containerRect = container.getBoundingClientRect();
    const defRect = defContainer.getBoundingClientRect();
    // const width = container.offsetWidth;
    const width = container.offsetWidth / 2;
    const height = container.offsetHeight;
    const offsetTop = containerRect.top - defRect.top + defContainer.offsetHeight / 2;
    // const offsetLeft = containerRect.left - defRect.left + defContainer.offsetWidth / 2 + 16;
    const offsetLeft = (container.offsetWidth/2 - defContainer.offsetWidth) * -1;
    const videoBannerTL = gsap.timeline({
        scrollTrigger: {
            trigger: '#s-hero',
            endTrigger: '#s-hero-video-container',
            start: 'top top',
            end: 'bottom bottom-=200',
            scrub: .5, 
        }
    });
    const formPinner = gsap.timeline({
        scrollTrigger: {
            trigger: '#s-hero',
            endTrigger: '#s-hero-video-container',
            start: 'top -200px',
            end: 'bottom bottom-=200', 
            pin: "#s-hero__form-cta"
        }
    });
    videoBannerTL.to('#s-hero__img-wrap-2', {
        // width: width, height: height, y: offsetTop, x: offsetLeft, ease: 'none'
        width: width, height: height, y: offsetTop, x: offsetLeft, ease: 'none'
    });
}
//--------------------------------------------------------------------
if (window.innerWidth > 991) {
    document.querySelectorAll('.s-event-collection-js').forEach((section) => {
        const cards = section.querySelectorAll('.event-item-js .event-card__content');
        if (cards.length === 3) {
            const card1 = cards[0], card2 = cards[1], card3 = cards[2];
            const card1Pic = card1.querySelector('.event-card__img-wrap-2'),
                card2Pic = card2.querySelector('.event-card__img-wrap-2'),
                card3Pic = card3.querySelector('.event-card__img-wrap-2');
            const trigger = section.querySelector('.s-event-collection__container');
            const card1Rect = card1.getBoundingClientRect();
            const triggerRect = trigger.getBoundingClientRect();
            const offsetTop = card1.offsetTop + 40;
            const offsetBottom = trigger.offsetHeight - (offsetTop - 40) - card1.offsetHeight;
            // Set initial Y position for cards
            gsap.set([card2, card3], {
                y: offsetTop
            });
            // Set initial styles for image wraps
            [card1Pic, card2Pic, card3Pic].forEach((pic) => {
                const h = pic.offsetHeight;
                gsap.set(pic, {
                    height: h * 1.2, y: h - h * 1.2
                });
            });
            // Timeline for card vertical movement
            const cardsTl = gsap.timeline({
                defaults: {ease: "none", duration: 1}, scrollTrigger: {
                    trigger: trigger, start: "top bottom", end: "bottom center", scrub: true, 
                }
            });
            cardsTl.to([card2, card3], {
                y: 0
            }).to(card1, {
                y: offsetBottom
            });
            // Timeline for images inside cards
            const cardsTl2 = gsap.timeline({
                defaults: {ease: "none", duration: 1}, scrollTrigger: {
                    trigger: trigger, start: "top bottom", end: "bottom top", scrub: true,
                }
            });
            cardsTl2.to([card1Pic, card2Pic, card3Pic], {
                y: 0, duration: 2
            });
        }
        if (cards.length === 2) {
            const card1 = cards[0], card2 = cards[1], card1Pic = card1.querySelector('.event-card__img-wrap-2'),
                card2Pic = card2.querySelector('.event-card__img-wrap-2');
            const trigger = section.querySelector('.s-event-collection__container');
            const offsetTop = card1.offsetTop;
            gsap.set(card2, {
                y: offsetTop
            });
            [card1Pic, card2Pic].forEach((pic) => {
                const h = pic.offsetHeight;
                gsap.set(pic, {
                    height: h * 1.2, y: h - h * 1.2
                });
            });
            const cardsTl = gsap.timeline({
                defaults: {ease: "none", duration: 1}, scrollTrigger: {
                    trigger: trigger, start: "top bottom", end: "bottom center", scrub: true, 
                }
            });
            cardsTl.to(card2, {
                y: 0
            });
            const cardsTl2 = gsap.timeline({
                defaults: {ease: "none", duration: 1}, scrollTrigger: {
                    trigger: trigger, start: "top bottom", end: "bottom top", scrub: true, 
                }
            });
            cardsTl2.to([card1Pic, card2Pic], {
                y: 0, duration: 2
            });
        }
        if (cards.length === 1) {
            const card1 = cards[0], card1Pic = card1.querySelector('.event-card__img-wrap-2');
            const trigger = section.querySelector('.s-event-collection__container');
            const h = card1Pic.offsetHeight;
            gsap.set(card1Pic, {
                height: h * 1.2, y: h - h * 1.2
            });
            const cardsTl2 = gsap.timeline({
                defaults: {ease: "none", duration: 1}, scrollTrigger: {
                    trigger: trigger, start: "top bottom", end: "bottom top", scrub: true, 
                }
            });
            cardsTl2.to(card1Pic, {
                y: 0, duration: 2
            });
        }
    });
}
//--------------------------------------------------------------------
if (window.innerWidth > 991) {
    document.querySelectorAll('.s-merch__pics-js').forEach((section) => {
        const logo = section.querySelector('.s-merch__pic-logo-vertical-wrap-2-js');
        if (!logo) return;
        const tl = gsap.timeline({
            defaults: {
                duration: 1, ease: 'power3.inOut',
            }, scrollTrigger: {
                trigger: section, start: 'top bottom-=200', once: true, 
            }
        });
        tl.from(logo, {y: -80});
    });
}
//--------------------------------------------------------------------
document.querySelectorAll('.s-review-slider-wrap-js:not(.s-review-slider-wrap-disable-anim-js)').forEach((wrap) => {
    const slider = wrap.querySelector('.s-review-slider-js');
    const pics = wrap.querySelectorAll('.s-review-slider__pic-slider-pic-js');
    if (!slider || !pics.length) return;
    if (window.innerWidth > 991) {
        gsap.set(slider, {
            yPercent: -70
        });
        const tl1 = gsap.timeline({
            defaults: {
                duration: 1, ease: 'none'
            }, scrollTrigger: {
                trigger: wrap, start: 'top bottom', end: 'bottom bottom', scrub: true, 
            }
        });
        tl1.to(slider, {
            yPercent: 0
        });
    }
    const picHeight = pics[0].offsetHeight;
    pics.forEach(pic => {
        pic.style.height = (picHeight * 1.2) + 'px';
    });
    const tl2 = gsap.timeline({
        defaults: {
            duration: 1, ease: 'none'
        }, scrollTrigger: {
            trigger: wrap, start: 'top bottom', end: 'bottom top', scrub: true, 
        }
    });
    tl2.from(pics, {
        yPercent: -20
    });
});
//--------------------------------------------------------------------
if (!document.querySelector('.disabled-smooth-scroll-js') && document.querySelector('.enable-footer-anim-js')) {
    if (document.getElementById('footer-my-wrap') && window.innerWidth > 991) {
        let input_line = document.getElementById('form-cta__input-line'),
            footer_cols = document.querySelectorAll('.footer-my__col-js'),
            letters = document.querySelectorAll('.footer-my__logo-letter-js'),
            footer_logo = document.getElementById('footer-my__logo');
        // if(window.innerWidth > 991) {
        gsap.set(footer_logo, {y: -50})
        gsap.set(letters, {yPercent: -102});
        gsap.set(footer_cols, {x: 60, autoAlpha: 0})
        gsap.set(input_line, {scaleX: 0})
        // }
        gsap.set('#footer-my', {
            yPercent: -80
        });
        const tl1 = gsap.timeline({
            defaults: {
                duration: 1, ease: 'none'
            }, scrollTrigger: {
                trigger: '#footer-my-wrap', start: 'top bottom', end: 'bottom bottom', scrub: true, 
            }
        });
        tl1
        .to('#footer-my', {
            yPercent: 0
        }, 0)
        // if(window.innerWidth > 991) {
        tl1
        .to(footer_logo, {
            y: 0
        }, 0);
        const tl2 = gsap.timeline({
            defaults: {
                duration: .75, ease: 'power3.inOut',
            }, scrollTrigger: {
                trigger: '#footer-my__container--2', start: 'center bottom-=100', once: true, 
            }
        });
        tl2
        .to(letters, {
            stagger: .05, yPercent: 0
        })
        const tl3 = gsap.timeline({
            defaults: {
                duration: .75, ease: 'power3.inOut',
            }, scrollTrigger: {
                trigger: '#footer-my-wrap', start: 'center bottom-=100', once: true, 
            }
        });
        tl3
        .to(input_line, {
            scaleX: 1
        })
        .to(footer_cols, {
            autoAlpha: 1, x: 0
        }, '-=.35')
        // }
    }
}
//--------------------------------------------------------------------
const mainSwiperEl = document.querySelector('#s-hero-product__swiper');
const thumbsContainer = document.querySelector('#s-hero-product__swiper-thumbs');

if (mainSwiperEl && thumbsContainer) {
    const thumbItems = thumbsContainer.querySelectorAll('.swiper-slide');

    const mainSwiper = new Swiper(mainSwiperEl, {
        allowTouchMove: true, 
        grabCursor: true, 
        slidesPerView: 1,
        spaceBetween: 10,
        
        // Adding navigation buttons
        navigation: {
            nextEl: '.main-slider-button-next',
            prevEl: '.main-slider-button-prev',
        },

        on: {
            init: function () {
                if (thumbItems.length > 0) {
                    thumbItems[0].classList.add('is-active');
                }
            },
            
            slideChange: function () {
                const activeIndex = this.realIndex; 
                
                thumbItems.forEach((item, index) => {
                    if (index === activeIndex) {
                        item.classList.add('is-active');
                        // Scroll thumbnail into view when main slide changes
                        item.scrollIntoView({ 
                            behavior: 'smooth', 
                            block: 'nearest', 
                            inline: 'center' 
                        });
                    } else {
                        item.classList.remove('is-active');
                    }
                });
            }
        }
    });

    // Clicking on thumbnails to control the main slider
    thumbItems.forEach((item, index) => {
        item.addEventListener('click', () => {
            mainSwiper.slideTo(index);
        });
    });
}
//--------------------------------------------------------------------
let filter_titles = document.querySelectorAll('.s-merch-collection__filters-block-inner-title');
filter_titles.forEach(function (btn) {
    btn.addEventListener('click', function () {
        const block = btn.closest('.s-merch-collection__filters-block-inner');
        const content = block.querySelector('.s-merch-collection__filters-block-inner-content');
        btn.classList.add('pointer-event-none');
        if (block.classList.contains('is-open')) {
            block.classList.remove('is-open');
            slideUp(content, 500, function () {
                btn.classList.remove('pointer-event-none');
            });
        } else {
            block.classList.add('is-open');
            slideDown(content, 500, function () {
                btn.classList.remove('pointer-event-none');
            });
        }
    });
});
//--------------------------------------------------------------------
function updateSelectWidth(select, measurer) {
    const selectedText = select.options[select.selectedIndex].text;
    measurer.textContent = selectedText;
    select.style.width = (measurer.offsetWidth + 20) + 'px';
}
function initDynamicSelects() {
    const selects = document.querySelectorAll('select.dynamic-width-js');
    selects.forEach((select) => {
        const measurer = document.createElement('span');
        measurer.className = 'select-measurer-js';
        select.parentNode.insertBefore(measurer, select.nextSibling);
        const resize = () => updateSelectWidth(select, measurer);
        select.addEventListener('change', resize);
        window.addEventListener('load', resize);
        resize();
    });
}
document.addEventListener('DOMContentLoaded', initDynamicSelects);
document.addEventListener('collection:updated', () => {
    initDynamicSelects();
});
//--------------------------------------------------------------------
if (window.innerWidth > 991) {
    window.addEventListener('load', () => {
        document.querySelectorAll('.s-highlight__container-js').forEach((item) => {
            const picWrap = item.querySelector('.s-highlight__pic-wrap-js');
            if (!picWrap) return;
            const offsetTop = picWrap.offsetTop;
            // console.log(offsetTop)
            gsap.set(picWrap, {
                y: -offsetTop
            });
            gsap.timeline({
                defaults: {
                    duration: 1, ease: 'none'
                }, scrollTrigger: {
                    trigger: item, start: 'top bottom', end: 'bottom bottom-=200', scrub: true,
                }
            }).to(picWrap, {
                y: 0
            });
        });
    });
}
//--------------------------------------------------------------------
if (document.querySelector('#s-hero-product__social-list') && window.innerWidth > 1299) {
    if (!document.body.classList.contains('is-hide-utility-bar') || !document.body.classList.contains('is-hide-utility-bar-2')) {
        utilityHeight = 38;
    }
    const socialList = document.querySelector('#s-hero-product__social-list');
    const container = document.querySelector('#s-hero-product__container');
    const socialListHeight = socialList.offsetHeight;

    const pinBlock = gsap.timeline({
        scrollTrigger: {
            trigger: socialList,
            endTrigger: container,
            start: `top top+=${headerHeight + utilityHeight + 16}`,
            end: `bottom top+=${headerHeight + utilityHeight + 16 + socialListHeight}`,
            pin: socialList
        }
    });
}
//--------------------------------------------------------------------
const animContainers = document.querySelectorAll('.container-anim-js');
if (animContainers.length > 0) {
    gsap.set(animContainers, {
        autoAlpha: 1,
    });
}
//-------------------------------------------------------------------
const header_wrap = document.getElementById('header-my-wrap');
const bodyContent = document.getElementById('body-content');
if (header_wrap && bodyContent && document.getElementById('s-merch-collection__container')) {
    bodyContent.insertBefore(header_wrap, bodyContent.firstChild);
    document.body.classList.add('is-special-page-styles');
}
//-------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
  const title = document.querySelector('.blog-title');
  const container = document.querySelector('#blog-container');

  if (title) {
     const splitLines = new SplitText(title, {
      type: 'lines',
      linesClass: 'blog-line'
    });
    const splitChars = new SplitText(splitLines.lines, {
      type: 'chars',
      charsClass: 'blog-char'
    });

     gsap.set(title, { opacity: 0, visibility: 'hidden' });
    gsap.set('.blog-line', { overflow: 'hidden' });
    gsap.set('.blog-char', { yPercent: 100, opacity: 0 });
    if (container) gsap.set(container, { opacity: 0, visibility: 'hidden' });

     const tl = gsap.timeline({
      defaults: { ease: 'power3.out' },
      delay: 0.3
    });

     tl.to(title, { opacity: 1, visibility: 'visible', duration: 0.1 });

     tl.to('.blog-char', {
      yPercent: 0,
      opacity: 1,
      duration: 0.6,
      stagger: {
        each: 0.03,
        from: 'start'
      }
    });

     if (container) {
      tl.to(container, {
        opacity: 1,
        visibility: 'visible',
        duration: 0.8
      }, '+=0.3'); 
    }
  }
});
//-------------------------------------------------------------------

$(document).ready(function () {
   if (document.querySelectorAll('.template-article').length > 0) {
        $(".article-template").addClass("show");
    }
});

$(window).on("load", function () {

    if (document.querySelectorAll('.template-article').length > 0) {

    gsap.registerPlugin(ScrollTrigger);
   
    if($(window).width() > 1200) {
         ScrollTrigger.create({
        trigger: ".article-template__content",
        start: "top 150px",
        end: self => "+=" + (document.querySelector(".article-template__content").offsetHeight - self.pin.offsetHeight),
        pin: "#toc",
        onRefresh: self => self.pin.parentNode.style.float = "left",
        pinSpacing: false, 
    });
     
        ScrollTrigger.create({
            trigger: ".article-template",
            start: "top 190px",
            end: self => "+=" + (document.querySelector(".article-template").offsetHeight - self.pin.offsetHeight),
            pin: ".sticky-link",
            onRefresh: self => self.pin.parentNode.style.float = "left",
            pinSpacing: false, 
        });
    }

    const content = document.querySelector(".article-template__content");
    const toc = document.querySelector("#toc");
    if (!content || !toc) return;

    const headings = content.querySelectorAll("h2, h3, h4, h5");
    if (!headings.length) return;

    const tocList = document.createElement("ol");
    tocList.classList.add("toc-list");

    headings.forEach((heading, i) => {
        const tag = heading.tagName.toLowerCase();
        const id = `section-${i + 1}`;
        heading.id = id;

        const li = document.createElement("li");
        li.className = `toc-${tag}`;

        const a = document.createElement("a");
        a.href = `#${id}`;
        a.textContent = heading.innerText.trim();
        a.className = "toc-link";

        li.appendChild(a);
        tocList.appendChild(li);
    });

    toc.appendChild(tocList);

    toc.addEventListener("click", (e) => {
        const link = e.target.closest("a.toc-link");
        if (!link) return;

        e.preventDefault();

        const hash = link.getAttribute("href");
        const target = document.querySelector(hash);
        if (!target) return;

        const headerOffset = getHeaderOffset(); 
        const y = target.getBoundingClientRect().top + window.scrollY - headerOffset;

        if (window.lenis && typeof window.lenis.scrollTo === "function") {
        window.lenis.scrollTo(y, { duration: 2, easing: (t) => t });
        } else {
        window.scrollTo({ top: y, behavior: "smooth" });
        }
    });

    function getHeaderOffset() {
        return 120;
    }

    const tocLinks = toc.querySelectorAll(".toc-link");

    tocLinks.forEach((link) => {
    const target = document.querySelector(link.getAttribute("href"));
    if (!target) return;

    ScrollTrigger.create({
        trigger: target,
        start: "top 120px",
        end: "bottom 120px",
        onEnter: () => setActive(link),
        onEnterBack: () => setActive(link),
        markers: false
    });
    });

    function setActive(activeLink) {
    tocLinks.forEach((l) => l.closest("li").classList.remove("active"));
    activeLink.closest("li").classList.add("active");
    }
}
});
//-------------------------------------------------------------------
 $(window).on("load", function () {
  if (window.innerWidth < 992 && $(".latest-posts-swiper").length) {
    new Swiper('.latest-posts-swiper', {
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: '.latest-posts-swiper-pagination',
        clickable: true,
      },
      grabCursor: true,
    });
  }
   if (window.innerWidth < 992 && $(".insta-posts-swiper").length) {
    new Swiper('.insta-posts-swiper', {
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: '.insta-posts-swiper-pagination',
        clickable: true,
      },
      grabCursor: true,
    });
  } 

if ($(".subscribe-sec").length) {
    gsap.to(".subscribe-sec",{
        delay: 1,
        autoAlpha: 1
    });

    let tl = gsap.timeline({
    scrollTrigger: {
        trigger: ".subscribe-sec",
        start: "top 120px",
        end: "bottom top",
        scrub: 2,
    }
    });

    if($(window).width() > 1200) {
    tl.to(".animated-image:nth-of-type(1)", { x: -10, y: 10, ease: "none" },0)
    .to(".animated-image:nth-of-type(2)", { x: 20,  y: 20, ease: "none" },0)
    .to(".animated-image:nth-of-type(3)", { x: -30,        ease: "none" },0)
    .to(".animated-image:nth-of-type(4)", { x: 40,  y: -15, ease: "none" },0);
    } else {
        tl.to(".animated-image:nth-of-type(1)", { x: -20, y: 10, ease: "none" },0) 
        .to(".animated-image:nth-of-type(4)", { x: 30,  y: -10, ease: "none" },0);
    }
}


 });

 window.addEventListener('klaviyoForms', function (e) { 
   
     $("form.klaviyo-form").addClass("klaviyo-ready");
  });


  document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const contactPosted = urlParams.get('contact_posted');
  const hasContactHash = window.location.hash === '#ContactForm';

  if (contactPosted === 'true' && hasContactHash) {
    const modal = document.querySelector('#modal-1');
    if (modal) {
      modal.classList.add('is-open');
    }
  }
});

